// apps/account-portal/src/components/Card.tsx
import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ children, className = '' }) => (
  <div className={`bg-[var(--surface)] rounded-xl p-6 border border-[var(--border-c)] [box-shadow:var(--card-shadow)] ${className}`}>
    {children}
  </div>
);

export default Card;
